'use strict';

{
  // 告知バー表示判定
  const announcementBar = document.querySelector('.announcement-bar-section');
  if (announcementBar) {
    document.body.classList.add('announcement-bar-true');
  }

  // ページ先頭に戻るボタン
  const pageTopButton = document.querySelector('.page-top');
  if (pageTopButton) {
    const pageTopButtonAnchor = pageTopButton.querySelector('a');

    const handleScroll = () => {
      if (window.scrollY >= 144) {
        pageTopButton.classList.add('active');
      } else {
        pageTopButton.classList.remove('active');
      }
    };

    const handleFocus = () => pageTopButton.classList.add('active');
    const handleBlur = () => pageTopButton.classList.remove('active');

    window.addEventListener('scroll', handleScroll);
    pageTopButtonAnchor.addEventListener('focus', handleFocus);
    pageTopButtonAnchor.addEventListener('blur', handleBlur);
  }

  //splide
  const stylingSplides = document.querySelectorAll('.splide-styling');
  if (stylingSplides.length > 0) {
    const optionsStyling = {
      fixedWidth: '156px',
      perPage: 1,
      gap: 18,
      pagination: false,
      arrowPath: 'M17.2417 10.5664L16.4561 11.3521L25.0986 19.9946L16.456 28.6372L17.2417 29.4229L26.6698 19.9948L26.6697 19.9946L26.6698 19.9945L17.2417 10.5664Z',
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    };

    stylingSplides.forEach((splide) => {
      new Splide(splide, optionsStyling).mount();
    });
  }

  const splides = document.querySelectorAll('.splides');
  if (splides.length > 0) {
    const options = {
      fixedWidth: '156px',
      perPage: 1,
      gap: 18,
      pagination: false,
      arrowPath: 'M17.2417 10.5664L16.4561 11.3521L25.0986 19.9946L16.456 28.6372L17.2417 29.4229L26.6698 19.9948L26.6697 19.9946L26.6698 19.9945L17.2417 10.5664Z',
      mediaQuery: 'min',
      breakpoints: {
        715: {
          fixedWidth: 'calc((100vw - (18px * 5)) / 4)',
          perPage: 4,
        },
        768: {
          fixedWidth: 'calc((100vw - (36px * 5)) / 4)',
          gap: 36,
        },
        1272: {
          fixedWidth: '273px',
        },
      },
    };

    splides.forEach((splide) => {
      new Splide(splide, options).mount();
    });
  }

  const splides2Line = document.querySelectorAll('.splides--twoLine');
  if (splides2Line.length > 0) {
    const options = {
      fixedWidth: '156px',
      perPage: 1,
      gap: 18,
      pagination: false,
      arrowPath: 'M17.2417 10.5664L16.4561 11.3521L25.0986 19.9946L16.456 28.6372L17.2417 29.4229L26.6698 19.9948L26.6697 19.9946L26.6698 19.9945L17.2417 10.5664Z',
      mediaQuery: 'min',
      destroy: true,
      drag: false,
      speed: 0,
      breakpoints: {
        715: {
          //fixedWidth: 'calc((100vw - (18px * 5)) / 4)',
          //perPage: 4,
        },
        768: {
          fixedWidth: 'calc((100vw - (36px * 5)) / 4)',
          gap: 36,
          speed: 400,
          destroy: false,
          drag: true,
        },
        1272: {
          fixedWidth: '273px',
        },
      },
    };

    splides2Line.forEach((splide) => {
      new Splide(splide, options).mount();
      mousedragscrollable(splide);
    });

    //マウスドラッグ
    function mousedragscrollable(element) {
      let target = null;
      const elm = element.querySelector('.splide__track');

      elm.addEventListener('mousedown', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        target = elm;
        target.dataset.down = 'true';
        target.dataset.move = 'false';
        target.dataset.x = evt.clientX;
        //target.dataset.y = evt.clientY;
        target.dataset.scrollleft = target.scrollLeft;
        //target.dataset.scrolltop = target.scrollTop;
      });

      elm.addEventListener('click', function (evt) {
        if (target && target.dataset.move === 'true') {
          evt.preventDefault();
          evt.stopPropagation();
          target.dataset.move = 'false';
        }
      });

      document.addEventListener('mousemove', function (evt) {
        if (target && target.dataset.down === 'true') {
          let move_x = parseInt(target.dataset.x, 10) - evt.clientX;
          //let move_y = parseInt(target.dataset.y, 10) - evt.clientY;
          if (move_x !== 0) {
            target.dataset.move = 'true';
            target.scrollLeft = parseInt(target.dataset.scrollleft, 10) + move_x;
            //target.scrollTop = parseInt(target.dataset.scrolltop, 10) + move_y;
          }
        }
      });

      document.addEventListener('mouseup', function (evt) {
        if (target) {
          target.dataset.down = 'false';
          if (target.dataset.move) {
          } else {
            target = null;
          }
        }
      });
    }
  }
}
